import type { VoidProps } from "solid-js";

export function Todo(_props: VoidProps<{}>) {
	return <h2>todo</h2>;
}
